import React from 'react';
import { cn } from "@/lib/utils";

interface SidebarHeaderProps {
  collapsed: boolean;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ collapsed }) => {
  return (
    <div className={cn(
      "flex items-center justify-center px-2",
      collapsed ? "justify-center" : ""
    )}>
      {/* Logo and title removed, content will be in Navbar */}
      {/* This div ensures consistent spacing for the sidebar header */}
    </div>
  );
};
